import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NextButton from './NextButton';
import BackButton from './BackButton';

const useStyles = makeStyles((theme: any) => ({
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    marginTop: theme.spacing(3),
  },
  footerButtons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
  },
  spaceBetweenButtons: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
}));

interface Props {
  nextButtonText?: string;
  hideBackButton?: boolean;
}

export default function BackForwardButtons({
  nextButtonText = null,
  hideBackButton = false,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <div className={classes.footerButtons}>
        {!hideBackButton && (
          <>
            <BackButton />
            <div className={classes.spaceBetweenButtons} />
          </>
        )}
        <NextButton nextButtonText={nextButtonText} />
      </div>
    </div>
  );
}
